import { BffBrandType, BffReviewsSelectionQuery } from '@/types/generated';

import { getGraphHeaders } from '@utils/getGraphHeaders';
import { logWarning } from '@utils/miscUtils';

export const getBffReviewsSelection = async (
	brand: BffBrandType,
	facilityCode: string,
	min: number,
	max: number,
	take: number,
	url: string,
	appDetails: {
		appName: string;
		appVersion: string;
	}
) => {
	try {
		const { getGraphQLClient } = await import(
			/* webpackChunkName:"getGraphQLClient" */ '@src/lib/graphql/getGraphQLClient'
		);
		return await getGraphQLClient(url).bffReviewsSelection(
			{
				brand,
				facilityCode,
				min,
				max,
				take,
			},
			getGraphHeaders(appDetails.appName, appDetails.appVersion)
		);
	} catch (err) {
		const errorMessage = err instanceof Error ? err.message : String(err);
		logWarning(`MISSING_SELECTED_REVIEWS: ${brand} for query: take = ${take}. ${errorMessage}`);
		return {
			reviewsSelection: [],
		} as BffReviewsSelectionQuery;
	}
};
